const getHistoryEntryWithFallback = (primaryHistory, providerHistory) => {
  if (!primaryHistory && !providerHistory) {
    return null;
  }

  const fallbackUser = primaryHistory?.user ?? providerHistory?.createdByName ?? null;
  const fallbackTimestamp = primaryHistory?.timestamp ?? providerHistory?.createdAt ?? null;

  if (!fallbackUser && !fallbackTimestamp) {
    return providerHistory ? { user: null, timestamp: null } : null;
  }

  return { user: fallbackUser, timestamp: fallbackTimestamp };
};

export default getHistoryEntryWithFallback;
